import actions from './actions';
import reducers from './reducers';

export default {
  actions,
  reducers
};
